export default __webpack_public_path__ + "static/media/DataScience.46f2daea.png";